export const questionnairestaff = [
    {
      date: "30 เมษายน 2569",
      title:
        "แบบสำรวจความพึงพอใจและความเชื่อมั่นคุณภาพวัคซีน (เจ้าหน้าที่ : ปศข.)  รหัส บ.ปศข./69",
      url: "https://forms.gle/23zDoafGHK33PEY28",
    },
  {
    date: "30 เมษายน 2569",
    title:
      "แบบสำรวจความพึงพอใจและความเชื่อมั่นคุณภาพวัคซีน (เจ้าหน้าที่ : ปศจ./สคบ.) รหัส บ.ปศจ.สคบ./69",
    url: "https://forms.gle/VbviUSx1M5ouiSZD7",
  },
];
